import React from 'react';
import { CompassIcon, SunIcon, SproutIcon } from 'lucide-react';
import { ScrollReveal } from './ScrollReveal';
export function AudienceSection() {
  const cards = [{
    icon: CompassIcon,
    title: 'Established Women Entrepreneurs',
    description: "You've already built a six-figure business, but it no longer reflects who you've become. You need a structured way to realign your leadership with your company's growth."
  }, {
    icon: SunIcon,
    title: 'Spiritually Aware Leaders',
    description: 'You have deep spiritual tools and awareness, but they feel separate from your business operations. You want to integrate your inner wisdom with your role as CEO.'
  }, {
    icon: SproutIcon,
    title: 'Founders Ready for Sustainable Scale',
    description: "You're done with hustle-based growth that leads to burnout. You want to expand your business in a way that creates more ease, not less, and builds true wealth."
  }];
  return <section className="py-28 px-6 bg-cream relative" data-id="element-4">
      <div className="max-w-7xl mx-auto" data-id="element-5">
        <ScrollReveal width="100%" className="mb-20 text-center" data-id="element-6">
          <span className="text-xs font-sans font-medium tracking-editorial text-slate uppercase border-b border-slate/20 pb-2 inline-block" data-id="element-7">
            Who This Is For
          </span>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-8">
          {cards.map((card, index) => <ScrollReveal key={index} delay={index * 0.2} className="h-full" data-id="element-9">
              <div className="h-full bg-cream-light border border-ink/10 p-10 md:p-12 flex flex-col items-start rounded-xl" data-id="element-10">
                <card.icon className="w-8 h-8 text-ink mb-8 stroke-[1.5]" data-id="element-11" />
                <h3 className="font-serif text-2xl md:text-3xl text-ink mb-4" data-id="element-12">
                  {card.title}
                </h3>
                <p className="font-sans text-slate text-base leading-relaxed font-light" data-id="element-13">
                  {card.description}
                </p>
              </div>
            </ScrollReveal>)}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-ink/10" data-id="element-14" />
    </section>;
}